import { createRoutine } from 'redux-saga-routines';

export const fetchSuccessPlanStatusLookups = createRoutine(
  'FETCH_SUC_PLAN_STATUS_LOOKUP'
);
export const fetchSuccessPlanProgressLookups = createRoutine(
  'FETCH_SUC_PLAN_PROGRESS_LOOKUP'
);
export const fetchMilestoneStatusLookups = createRoutine(
  'FETCH_MILESTONE_STATUS_LOOKUP'
);
export const fetchKPIProgressLookups = createRoutine(
  'FETCH_KPI_PROGRESS_LOOKUP'
);

// sp-v2

export const resetSuccessPlansV2 = createRoutine('RESET_SUCCESS_PLANS_V2');
export const changeSuccessPlanTabV2 = createRoutine(
  'CHANGE_SUCCESS_PLAN_TAB_V2'
);
export const fetchSuccessPlanStatusLookupsV2 = createRoutine(
  'FETCH_SUC_PLAN_STATUS_LOOKUP_v2'
);
export const fetchSuccessPlanProgressLookupsV2 = createRoutine(
  'FETCH_SUC_PLAN_PROGRESS_LOOKUP_v2'
);

export const fetchMilestoneStatusLookupsV2 = createRoutine(
  'FETCH_MILESTONE_STATUS_LOOKUP_V2'
);

export const fetchAllSuccessPlans = createRoutine('FETCH_ALL_SUCCESS_PLANS');
export const loadAllSuccessPlans = createRoutine('LOAD_ALL_SUCCESS_PLANS');
export const createSuccessPlanV2 = createRoutine('CREATE_SUCCESS_PLAN_V2');
export const editSuccessPlanV2 = createRoutine('EDIT_SUCCESS_PLAN_V2');
export const fetchSuccessPlanByIdV2 = createRoutine(
  'FETCH_SUCCESS_PLAN_BY_ID_V2'
);
export const successPlanDrawerState = createRoutine(
  'SUCCESS_PLAN_DRAWER_STATE'
);
export const fetchSuccessPlanStatusV2 = createRoutine(
  'FETCH_SUCCESS_PLAN_STATUS_V2'
);
export const completeSuccessPlanV2 = createRoutine('COMPLETE_SUCCESS_PLAN_V2');
export const cancelSuccessPlanCompleteV2 = createRoutine(
  'CANCEL_SUCCESS_PLAN_COMPLETE_V2'
);
export const markSuccessPlanInprogressV2 = createRoutine(
  'MARK_SUCCESS_PLAN_IN_PROGRESS_V2'
);
export const duplicateSuccessPlanV2 = createRoutine(
  'DUPLICATE_SUCCESS_PLAN_V2'
);
export const archiveSuccessPlanV2 = createRoutine('ARCHIVE_SUCCESS_PLAN_V2');

// -- Milestone sp v2  --
export const milestoneDrawerStateV2 = createRoutine(
  'MILESTONE_DRAWER_STATE_V2'
);
export const milestoneTaskDrawerStateV2 = createRoutine(
  'MILESTONE_TASK_DRAWER_STATE_V2'
);
export const milestoneTaskCompleteV2 = createRoutine(
  'MILESTONE_TASK_COMPLETE_V2'
);
export const createMilestoneV2 = createRoutine('CREATE_MILESTONE_V2');
export const editMilestoneV2 = createRoutine('EDIT_MILESTONE_V2');
export const fetchMilestonesV2 = createRoutine('FETCH_MILESTONES_V2');
export const fetchMilestoneByIdV2 = createRoutine('FETCH_MILESTONE_BY_ID_V2');

export const cancelMilestoneCompleteV2 = createRoutine(
  'CANCEL_MILESTONE_COMPLETE_V2'
);
export const fetchMilestoneStatusV2 = createRoutine(
  'FETCH_MILESTONE_STATUS_V2'
);
export const completeMilestoneV2 = createRoutine('COMPLETE_MILESTONE_V2');
export const markMilestoneInprogressV2 = createRoutine(
  'MARK_MILESTONE_IN_PROGRESS_V2'
);
export const archiveMilestoneV2 = createRoutine('ARCHIVE_MILESTONE_V2');
export const fetchSuccessPlanFilesV2 = createRoutine(
  'FETCH_SUCCESS_PLAN_FILES_V2'
);
export const refreshMilestoneBoardByIdV2 = createRoutine(
  'REFRESH_MILESTONE_BOARD_BY_ID_V2'
);
export const updateRefreshMilestoneIds = createRoutine(
  'UPDATE_REFRESH_MILESTONE_IDS'
);

// -- KPI sp v2  --

export const fetchKPIProgressLookupsV2 = createRoutine(
  'FETCH_KPI_PROGRESS_LOOKUP_V2'
);
export const fetchKPIsV2 = createRoutine('FETCH_KPIS_V2');
export const fetchKPIByIdV2 = createRoutine('FETCH_KPI_BY_ID_V2');
export const createKPIV2 = createRoutine('CREATE_KPI_V2');
export const editKPIV2 = createRoutine('EDIT_KPI_V2');
export const archiveKPIV2 = createRoutine('ARCHIVE_KPI_V2');
export const resetKPIsV2 = createRoutine('RESET_KPI_V2');

// -- sp v2 end --

export const fetchSuccessPlans = createRoutine('FETCH_SUCCESS_PLANS');
export const fetchSuccessPlanById = createRoutine('FETCH_SUCCESS_PLAN_BY_ID');
export const createSuccessPlan = createRoutine('CREATE_SUCCESS_PLAN');
export const editSuccessPlan = createRoutine('EDIT_SUCCESS_PLAN');
export const archiveSuccessPlan = createRoutine('ARCHIVE_SUCCESS_PLAN');
export const unArchiveSuccessPlan = createRoutine('UNARCHIVE_SUCCESS_PLAN');
export const fetchSuccessPlanFiles = createRoutine('FETCH_SUCCESS_PLAN_FILES');

export const fetchSuccessPlanStatus = createRoutine(
  'FETCH_SUCCESS_PLAN_STATUS'
);
export const cancelSuccessPlanComplete = createRoutine(
  'CANCEL_SUCCESS_PLAN_COMPLETE'
);
export const completeSuccessPlan = createRoutine('COMPLETE_SUCCESS_PLAN');
export const markSuccessPlanInprogress = createRoutine(
  'MARK_SUCCESS_PLAN_IN_PROGRESS'
);
export const duplicateSuccessPlan = createRoutine('DUPLICATE_SUCCESS_PLAN');

export const fetchMilestones = createRoutine('FETCH_MILESTONES');
export const fetchMilestoneById = createRoutine('FETCH_MILESTONE_BY_ID');
export const createMilestone = createRoutine('CREATE_MILESTONE');
export const editMilestone = createRoutine('EDIT_MILESTONE');
export const fetchMilestoneStatus = createRoutine('FETCH_MILESTONE_STATUS');
export const cancelMilestoneComplete = createRoutine(
  'CANCEL_MILESTONE_COMPLETE'
);
export const completeMilestone = createRoutine('COMPLETE_MILESTONE');
export const markMilestoneInprogress = createRoutine(
  'MARK_MILESTONE_IN_PROGRESS'
);
export const archiveMilestone = createRoutine('ARCHIVE_MILESTONE');

export const resetSuccessPlans = createRoutine('RESET_SUCCESS_PLANS');
export const resetMileStones = createRoutine('RESET_MILESTONES');

export const fetchKPIs = createRoutine('FETCH_KPIS');
export const fetchKPIById = createRoutine('FETCH_KPI_BY_ID');
export const createKPI = createRoutine('CREATE_KPI');
export const editKPI = createRoutine('EDIT_KPI');
export const archiveKPI = createRoutine('ARCHIVE_KPI');
export const resetKPIs = createRoutine('RESET_KPI');
